import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import datepickerKoFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ko';
import 'timepicker';

datepickerFactory($);
datepickerKoFactory($);

gsap.registerPlugin(ScrollTrigger);

const initAll = () => {
  const aniOpacity = gsap.utils.toArray('.ani-opacity');

  aniOpacity.forEach((ele) => {
    ele.classList.add('ani-opacity-1');
  })

  // 날짜 입력
  $(document).on('focus', '.input-datepicker', function() {
  // $('.input-datepicker').on('click', function() {
    var $this = $(this);
    $this.datepicker({
      dateFormat: 'yy/mm/dd',
      showButtonPanel: true,
      changeMonth: true,
      changeYear: true,
      // yearRange: '2000:2020',
    });
  });
  $.datepicker.regional['ko'];

  // $('.input-datepicker').datepicker("setDate", new Date());

  // 시간 입력
  $('.input-timepicker').timepicker({
    'timeFormat': 'H:i',
    'step' : 60,
  });
  $('.input-timepicker2').timepicker({
    'timeFormat': 'H:i',
    'step' : 60,
    'minTime' : '09:00am',
    'maxTime' : '18:00pm',
  });

  $('.custom-file-input').on('change', function(e) {
    var $this = $(this);
    var fileSize = e.target.files[0].size;

    if ( 10000000 < fileSize ) {
      alert('파일 사이즈는 10MB 이하여야 합니다.');
      $this.next('.custom-file-label').html('10MB 이하(zip, hwp, doc, excel, txt 파일만 가능)');
    }
  });
}

export default initAll;
